import { render, staticRenderFns } from "./RiderDisciplineCreate.vue?vue&type=template&id=20ceedc3&lang=pug"
import script from "./RiderDisciplineCreate.vue?vue&type=script&lang=js"
export * from "./RiderDisciplineCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports